export default __webpack_public_path__ + "static/media/SEC1430.34I-32568_-17854_0.f431735b.jpg";